import Image from "next/image";

type BannerProps = {
  firstLine: string;
  secondLine?: string;
};

export const Banner = ({ firstLine, secondLine }: BannerProps) => {
  return (
    <div className="flex overflow-hidden relative flex-col justify-center py-24 px-5 mb-8 w-full min-h-[170px] max-h-[170px] text-center text-yellow rounded-xl md:mb-[60px] md:min-h-[320px] md:max-h-[320px]">
      <Image
        priority
        layout="fill"
        src="/images/seo/banner.webp"
        alt="banner"
        className="object-cover object-[center_25%] absolute top-0 left-0 -z-10 w-full h-full brightness-50"
        style={{ objectPosition: "top" }}
      />
      <h1>
        <span
          className="relative before:absolute before:top-[1px] before:left-[4px] before:-z-10 before:-mx-1 before:w-full text-3xl font-bold before:text-black text-yellow md:before:top-[4px] md:text-[60px] md:leading-[62px] lg:text-6xl"
          style={{
            textShadow:
              "1px 0 black, 0px 1px black, -1px 0 black, 0 -1px black, 2px 2px black, 1px 1px black, 1.5px 1.5px black, 2.5px 2.5px black, 3px 3px black, 3.5px 3.5px black",
          }}
        >
          {firstLine}
        </span>
        {secondLine && (
          <>
            <br />
            <span
              className="relative before:absolute before:top-[1px] before:left-[4px] before:-z-10 before:-mx-1 before:w-full text-3xl font-bold before:text-black text-yellow md:before:top-[4px] md:text-[60px] md:leading-[62px] lg:text-6xl"
              style={{
                textShadow:
                  "1px 0 black, 0px 1px black, -1px 0 black, 0 -1px black, 2px 2px black, 1px 1px black, 1.5px 1.5px black, 2.5px 2.5px black, 3px 3px black, 3.5px 3.5px black",
              }}
            >
              {secondLine}
            </span>
          </>
        )}
      </h1>
    </div>
  );
};
